<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('medicine')"
          :class="[
            'nav-link link-nav-resident',
            step == 'medicine' && 'active',
          ]"
          id="nav-medicine"
          data-toggle="tab"
          href="#medicine"
          role="tab"
          aria-controls="medicine"
          aria-selected="true"
          >MEDICAMENTO</a
        >
        <a
          @click="handleStep('product')"
          :class="['nav-link link-nav-resident', step == 'product' && 'active']"
          id="nav-product"
          data-toggle="tab"
          href="#product"
          role="tab"
          aria-controls="product"
          aria-selected="true"
          >PRODUTO</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'medicine'"
        :class="['tab-pane fade', step == 'medicine' && 'show active']"
        id="medicine"
        role="tabpanel"
        aria-labelledby="nav-medicine"
      >
        <medicine />
      </div>
      <div
        v-if="step == 'product'"
        :class="['tab-pane fade', step == 'product' && 'show active']"
        id="product"
        role="tabpanel"
        aria-labelledby="nav-product"
      >
        <product />
      </div>
    </div>
  </div>
</template>

<script>
import Medicine from "./sale/medicine";
import Product from "./sale/product";

import routes from "../../../routes";

export default {
  name: "Sale",

  components: {
    Medicine,
    Product,
  },

  created() {
    this.retrieve();
  },

  data() {
    return {
      step: "medicine",

      errors: [],
    };
  },

  methods: {
    handleStep(step) {
      let { menu, tipo, acao, venda } = routes.history.current.query;

      if (venda != step) {
        routes.replace({ query: { menu, tipo, venda: step, acao } });
      }

      this.step = step;
    },

    retrieve() {
      let { menu, tipo, acao, venda } = this.$router.currentRoute.query;

      if (!venda) {
        this.$router.replace({
          query: { menu, tipo, venda: "medicine", acao },
        });
        this.step = "medicine";
      } else {
        if (["medicine", "product"].includes(venda)) {
          this.step = venda;
        } else {
          this.step = "medicine";
        }
      }
    },
  },
};
</script>